import { render, staticRenderFns } from "./vip_packages.vue?vue&type=template&id=813d1c2e&scoped=true&"
import script from "./vip_packages.vue?vue&type=script&lang=js&"
export * from "./vip_packages.vue?vue&type=script&lang=js&"
import style0 from "./vip_packages.vue?vue&type=style&index=0&id=813d1c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813d1c2e",
  null
  
)

export default component.exports